import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import DhabiSadIcon from '../Icons/DhabiSadIcon';
import { ERROR_MESSAGES } from './messageActions';

const ErrorMessage = ({ message, traceId, actionButtonText, onClick }) => (
  <Wrapper>
    <ErrorWrapper>
      <div>
        <DhabiSadIcon className={'push--bottom'} size={100} />
      </div>
      <MessageWrapper>
        <h2>{message}</h2>
        {traceId && <h2>[ Trace ID: {traceId} ]</h2>}
      </MessageWrapper>
      <ButtonWrapper>
        <button className={'btn'} onClick={onClick}>
          {actionButtonText}
        </button>
      </ButtonWrapper>
    </ErrorWrapper>
  </Wrapper>
);

const Wrapper = styled.div`
  background-color: white;
  height: 100vh;
  width: 100vw;
`;

const ErrorWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  align-items: center;
  text-align: center;

  position: absolute;
  top: 20%;
  left: 50%;
  transform: translate(-50%);
  width: 90%;
`;

const MessageWrapper = styled.div`
  text-align: center;

  h2 {
    display: block;
    color: var(--tundora);
    font-size: var(--font-size-large);
  }
`;

const ButtonWrapper = styled.div`
  button {
    font-family: 'OpenSans', sans-serif;
    font-size: var(--font-size-large);
    font-weight: 600;
    width: 200px;
    height: 35px;
    padding: 0 15px;
    color: white;
    background-color: var(--eastern-blue);
    text-transform: uppercase;

    &:hover {
      background-color: white;
      color: var(--tundora);
      border: solid 2px var(--eastern-blue);
    }
  }
`;

ErrorMessage.defaultProps = {
  message: ERROR_MESSAGES.GENERIC.message,
  traceId: '',
  actionButtonText: ERROR_MESSAGES.GENERIC.action,
  onClick: ERROR_MESSAGES.GENERIC.callback,
};

ErrorMessage.propTypes = {
  message: PropTypes.string,
  traceId: PropTypes.string,
  actionButtonText: PropTypes.string,
  onClick: PropTypes.func,
};

export default ErrorMessage;
